var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUxpTokenIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 75 75",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 37.5,
    cy: 37.5,
    r: 37,
    fill: "#000",
    stroke: "#333"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M58.596 37.653a20.82 20.82 0 00-1.64-8.131 20.948 20.948 0 101.64 8.13zm0 0h-.3.3s0 0 0 0zm-1.638 0v0c0 1.144-.1 2.286-.302 3.412H50.4L38.53 29.194V18.421c10.25.43 18.429 8.875 18.429 19.231zm-38.496 0v0c0-10.357 8.178-18.803 18.428-19.232v10.773l-11.87 11.87h-6.256a19.335 19.335 0 01-.302-3.412zm31.384 5.05h6.442C54.068 50.885 46.592 56.9 37.71 56.9s-16.36-6.016-18.578-14.196h6.565l.088-.088L37.71 30.692l11.924 11.924.088.088h.124z",
    fill: "#fff",
    stroke: "#fff",
    strokeWidth: 0.6
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUxpTokenIcon);
export default __webpack_public_path__ + "static/media/UXP-token-icon.fc4a02005b13fd2acc7fa73e25f52df6.svg";
export { ForwardRef as ReactComponent };